import AssistPag from '@/views/admin/assistencia/pagamentos/'
import AssistPagEdit from '@/views/admin/assistencia/pagamentos/Edit'
import AssistLoad from '@/views/admin/assistencia/pagamentos/Save'
import AssistBeneficios from '@/views/admin/assistencia/beneficios/'
import AssistBeneficiosSave from '@/views/admin/assistencia/beneficios/Save'

export const assistencia = [
  {
    path: 'assistencia',
    redirect: 'assistencia/beneficios',
    component: () => import('@/views/admin/assistencia'),
    children: [
      {
        path: 'pagamentos',
        component: AssistPag,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      },
      {
        path: 'pagamentos/edit',
        name: 'pagamentos_edit',
        component: AssistPagEdit,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      },
      {
        path: 'load',
        component: AssistLoad,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      },
      {
        path: 'beneficios',
        component: AssistBeneficios,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      },
      {
        path: 'beneficios/edit',
        name: 'beneficios_edit',
        component: AssistBeneficiosSave,
        meta: {
          requiresAuth: true,
          userAuth: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/assistencia.js